import { render, staticRenderFns } from "./SalesReturnSettle.vue?vue&type=template&id=0c8bcf79&scoped=true"
import script from "./SalesReturnSettle.vue?vue&type=script&lang=js"
export * from "./SalesReturnSettle.vue?vue&type=script&lang=js"
import style0 from "./SalesReturnSettle.vue?vue&type=style&index=0&id=0c8bcf79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8bcf79",
  null
  
)

export default component.exports